import { createContext, useContext, useReducer } from 'react';
import { AmendmentSearchState, AmendmentSearchReducer, ACTION_TYPES } from './amendment-search-reducer';

const AmendmentSearchContext = createContext<AmendmentSearchState | undefined>(undefined);
const AmendmentSearchDispatchContext = createContext({} as any);

const AmendmentSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: AmendmentSearchState = {
        parameters: { page: 0, pageSize: 25 },
        parlamentarians: [],
        politicalParties: [],
        budgetUnits: [],
        budgetPrograms: [],
        budgetActions: [],
        searchTrigger: 0,
    };
    const [state, dispatch] = useReducer(AmendmentSearchReducer, initialState);
    return (
        <AmendmentSearchContext.Provider value={state}>
            <AmendmentSearchDispatchContext.Provider value={dispatch}>
                {children}
            </AmendmentSearchDispatchContext.Provider>
        </AmendmentSearchContext.Provider>
    );
};

const useAmendmentSearchState = () => {
    const context = useContext(AmendmentSearchContext);
    if (!context) throw new Error('useAmendmentSearchState must be used within AmendmentSearchProvider');
    return context;
};

const useAmendmentSearchDispatch = () => {
    const context = useContext(AmendmentSearchDispatchContext);
    if (!context) throw new Error('useAmendmentSearchDispatch must be used within AmendmentSearchProvider');
    return context;
};

export { AmendmentSearchProvider, useAmendmentSearchState, useAmendmentSearchDispatch, ACTION_TYPES };
